var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { color, textAlign, padding, flexbox, grid, borderRadius, margin, borderColor, position } from 'styled-system';
var BaseBox = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), color, padding, borderRadius, margin, borderColor, flexbox, grid, position, textAlign);
export default BaseBox;
var templateObject_1;
